import 'zone.js';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { PayoutAccountSelectorModule } from './payout-account-selector/payout-account-selector.module';
import { environment } from './environments/environment';

if (environment.production && !environment.prodEnabled) {
  enableProdMode();
  environment.prodEnabled = true;
}

platformBrowserDynamic().bootstrapModule(PayoutAccountSelectorModule)
  .catch((err) => console.error(err));
